import _ from 'lodash'
import isEmpty from 'lodash/isEmpty'

// eslint-disable-next-line
export const fullName = person => `${_.upperFirst(_.lowerCase(person.first_name))} ${_.upperFirst(_.lowerCase(person.last_name))}`

export const getCompanyById = (companies, id) => {
  if (id === -1 || id === undefined || id === null || id === 'null') {
    if (!isEmpty(companies)) {
      localStorage.setItem('app.settings.company', companies[0].id)
      return companies[0]
    }
  }
  localStorage.setItem('app.settings.company', id)
  return companies.filter(c => c.id === parseInt(id, 10))
}
